import { render } from "./AppConfig.vue?vue&type=template&id=8e5ac876"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__